import TableWidget from './TableWidget';
import type { TableWidgetProps } from './TableWidget.types';

export type { TableWidgetProps };
export { TableWidget };
export default TableWidget;
